<script setup>
import {computed, ref, watch} from "vue"
import { useToast } from "vue-toastification"

const props = defineProps({
    day: {
        type: String,
        required: true
    },
})

watch( ()=> props.day, (newValue, oldValue) => {
    if (newValue !== oldValue) {
        form.value.punch_time = newValue
    }
})

const emit = defineEmits(['close'])
const toast = useToast()
const applyPunch = ref(null)
const form = ref({
    duty: 'on',
    location: 'company',
    punch_time: props.day,
    remark: null
})

const lastApplyDate = computed(()=> {
    const day = dayjs().date()
    if (day > 5) {
        return dayjs().startOf('month').format('YYYY-MM-DD')
    }
    return dayjs().subtract(1, 'month').startOf('month').format('YYYY-MM-DD')
})

async function checkForm(e){
    form.value.punch_time = dayjs(form.value.punch_time).format('YYYY-MM-DD HH:mm:ss')
    e.preventDefault()
    try {
        const response = await axios.post('/api/punches/apply', form.value)
        toast.success(response.data.message)
        applyPunch.value.reset()
        emit('close')
    } catch (error) {
        toast.error(error.response.data.message)
    }

}

</script>

<template>
    <form ref="applyPunch" class="rounded bg-gray-400 py-4 px-2" @submit="checkForm">
        <div class="flex-col">
            <div class="text-white my-1">Type</div>
            <select class="w-full" v-model="form.duty" id="type">
                <option value="on">punch on</option>
                <option value="off">punch off</option>
            </select>
        </div>
        <div class="flex-col">
            <div class="text-white my-1">Location</div>
            <select class="w-full" v-model="form.location" id="location">
                <option value="company">Company</option>
                <option value="client">Client</option>
                <option value="home">Home</option>
            </select>
        </div>
        <div class="flex-col">
            <div class="text-white my-1">Punch time</div>
            <v-date-picker
                :is-expanded="true"
                v-model="form.punch_time"
                mode="dateTime"
                :max-date='new Date()'
                :min-date="lastApplyDate"
            />
        </div>
        <div class="flex-col">
            <div class="text-white my-1">Reason</div>
            <input class="w-full text-lg p-1" v-model="form.remark" id="remark">
        </div>
        <div class="flex justify-center items-center my-1">
            <input class="rounded  px-2 py-1 bg-indigo-400 text-white" type="submit" value="submit">
        </div>
    </form>
</template>
